<template>
  <v-tabs v-model="currentItem" background-color="transparent" color="black" hide-slider show-arrows v-if="!isUserPage">
    <v-tab v-for="item in tabItems" :key="item" :href="'#tab-' + item" color="black">
      <p color="black" class="pt-3">{{ item }}</p>
    </v-tab>
  </v-tabs>
</template>

<script>
// Import from vuex
import { mapGetters } from "vuex";
export default {
  data(){
    return{
      currentItem: '',
      tabItems: [
        'Front Page','Web', 'Shopping', 'Videos', 'Images', 'My EPIC STUFF', 'TEST TEST TEAST', 'QWERTTYYY', 'ABCDE FGHIJKL', 'NEI HAR DU SETT'
      ],
    }
  },
  computed: {
    // ...mapGetters(["authStatus", "isLoggedIn", "fullName", "updateStatus", "getLang"]),
    // isLogin() {
    //   return this.$route.name ==='login' 
    //   || this.$route.name ==='register'
    // },
    isUserPage() {
      return this.$route.name ==='listarticles' 
      // || this.$route.name =='dashboard' 
      || this.$route.name ==='editprofile' 
      || this.$route.name ==='createarticle' 
      || this.$route.name ==='profilesettings' 
      || this.$route.name ==='editfrontpagesettings'
      || this.$route.name ==='inbox'
      || this.$route.name ==='follows'
      || this.$route.name ==='managefeeds'
      || this.$route.name ==='editarticle'
    }
  },
}
</script>